import { render, staticRenderFns } from "./CommonLabels.vue?vue&type=template&id=446c72b9"
import script from "./CommonLabels.vue?vue&type=script&lang=js"
export * from "./CommonLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports